// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3bJNId_dfmClyIopQ83oeT"};